import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1UserPreferencesUpdatePreferencesPartialUpdate: build.mutation<
      ApiPortalV1UserPreferencesUpdatePreferencesPartialUpdateApiResponse,
      ApiPortalV1UserPreferencesUpdatePreferencesPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/user-preferences/${queryArg.id}/update_preferences/`,
        method: "PATCH",
        body: queryArg.patchedUserPreferences,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1UserPreferencesUpdatePreferencesPartialUpdateApiResponse =
  /** status 200  */ UserPreferences;
export type ApiPortalV1UserPreferencesUpdatePreferencesPartialUpdateApiArg = {
  /** A unique integer value identifying this account. */
  id: number;
  patchedUserPreferences: PatchedUserPreferences;
};
export type UserPreferences = {
  first_name?: string;
  last_name?: string;
  guided_experience_state?: {
    [key: string]: any;
  } | null;
};
export type PatchedUserPreferences = {
  first_name?: string;
  last_name?: string;
  guided_experience_state?: {
    [key: string]: any;
  } | null;
};
export const {
  useApiPortalV1UserPreferencesUpdatePreferencesPartialUpdateMutation,
} = injectedRtkApi;
